import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SimpleformsComponent } from './simpleforms.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: '', component: SimpleformsComponent }
    ])
  ],
  exports: [RouterModule]
})
export class SimpleformsRoutingModule { }
